<template>
  <yd-layout>
    <yd-navbar v-if="showHeader" :title="title" :fontsize="fontsize" :bgcolor="bgcolor" :color="color"   :height="height" :fixed="fixed" style="top: -1px;">
      <div slot="left" >
        <slot name="header-left"></slot>
      </div>
      <div slot="right" >
        <slot name="header-right"></slot>
       </div>
    </yd-navbar>

    <div class="main-container">
      <slot></slot>
    </div>

    <yd-tabbar v-if="showFooter" fixed fontsize="0.28rem" style="padding: 0;">
      <slot name="tabbar">
        <yd-tabbar-item title="首页" link="/home"  >
          <yd-icon name="home" slot="icon" size="0.5rem"></yd-icon>
        </yd-tabbar-item>
        <yd-tabbar-item title="其他" link="/shopcart"  >
          <yd-icon name="shopcart-outline" slot="icon" size="0.5rem"></yd-icon>
        </yd-tabbar-item>
        <yd-tabbar-item title="个人中心" link="/ucenter" >
          <yd-icon name="ucenter-outline" slot="icon" size="0.5rem"></yd-icon>
          <yd-badge slot="badge" type="danger">2</yd-badge>
        </yd-tabbar-item>
      </slot>
    </yd-tabbar>

  </yd-layout>
</template>

<script>
  export default {
    name: 'AppLayout',
    props: {
      fontsize: {
        type: String,
        default: '.34rem',
      },
      showHeader: {
        type: Boolean,
        default: true,
      },
      showBack: {
        type: Boolean,
        default: true,
      },
      showFooter: {
        type: Boolean,
        default: true,
      },
      title: {
        type: String,
        default: '',
      },
      bgcolor: {
        type: String,
        default: '#19b4e7',
      },
      color: {
        type: String,
        default: '#fff',
      },
      height: {
        type: String,
        default: '1rem',
      },
      fixed: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
      };
    },
    created() {
      if (this.isWeiXin) {
        // this.showHeader = false;
        document.title = this.title;
        const iframe = document.createElement('iframe');
        iframe.src = './favicon.ico';
        iframe.style.display = 'none';
        iframe.onload = () => {
          setTimeout(() => {
            document.body.removeChild(iframe);
          }, 0);
        };
        document.body.appendChild(iframe);
      }
    },
    methods: {
      goBack() {
        this.$router.go(-2);
        return false;
      },
      isWeiXin() {
        const ua = window.navigator.userAgent.toLowerCase();
        const res = ua.match(/MicroMessenger/i);
        return res === 'micromessenger';
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '../../styles/base';

  .main-container{
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    max-height: 100%;
  }
  .borderBottom{
    border-bottom: 6px solid $borderBottomColor;
  }
  .yd-navbar:after{
    border-bottom: none;
  }
</style>



// WEBPACK FOOTER //
// index.vue?134f3378